/** Auto-generated staple WebP requires — do not edit by hand. */
export const CATALOG_STAPLE_IMAGES: Record<string, number> = {
  potato: require('../../assets/staples/potato.webp'),
  onion: require('../../assets/staples/onion.webp'),
  spring_onion: require('../../assets/staples/spring_onion.webp'),
  shallot: require('../../assets/staples/shallot.webp'),
  tomato: require('../../assets/staples/tomato.webp'),
  garlic: require('../../assets/staples/garlic.webp'),
  ginger: require('../../assets/staples/ginger.webp'),
  green_chilli: require('../../assets/staples/green_chilli.webp'),
  carrot: require('../../assets/staples/carrot.webp'),
  beetroot: require('../../assets/staples/beetroot.webp'),
  radish: require('../../assets/staples/radish.webp'),
  cauliflower: require('../../assets/staples/cauliflower.webp'),
  cabbage: require('../../assets/staples/cabbage.webp'),
  broccoli: require('../../assets/staples/broccoli.webp'),
  capsicum: require('../../assets/staples/capsicum.webp'),
  brinjal: require('../../assets/staples/brinjal.webp'),
  okra: require('../../assets/staples/okra.webp'),
  bottle_gourd: require('../../assets/staples/bottle_gourd.webp'),
  ridge_gourd: require('../../assets/staples/ridge_gourd.webp'),
  bitter_gourd: require('../../assets/staples/bitter_gourd.webp'),
  snake_gourd: require('../../assets/staples/snake_gourd.webp'),
  ash_gourd: require('../../assets/staples/ash_gourd.webp'),
  pumpkin: require('../../assets/staples/pumpkin.webp'),
  cucumber: require('../../assets/staples/cucumber.webp'),
  zucchini: require('../../assets/staples/zucchini.webp'),
  tinda: require('../../assets/staples/tinda.webp'),
  tindora: require('../../assets/staples/tindora.webp'),
  drumstick: require('../../assets/staples/drumstick.webp'),
  raw_banana: require('../../assets/staples/raw_banana.webp'),
  raw_papaya: require('../../assets/staples/raw_papaya.webp'),
  raw_mango: require('../../assets/staples/raw_mango.webp'),
  green_peas: require('../../assets/staples/green_peas.webp'),
  french_beans: require('../../assets/staples/french_beans.webp'),
  cluster_beans: require('../../assets/staples/cluster_beans.webp'),
  broad_beans: require('../../assets/staples/broad_beans.webp'),
  double_beans: require('../../assets/staples/double_beans.webp'),
  corn: require('../../assets/staples/corn.webp'),
  mushroom: require('../../assets/staples/mushroom.webp'),
  spinach: require('../../assets/staples/spinach.webp'),
  fenugreek_leaves: require('../../assets/staples/fenugreek_leaves.webp'),
  amaranth_leaves: require('../../assets/staples/amaranth_leaves.webp'),
  mustard_greens: require('../../assets/staples/mustard_greens.webp'),
  dill_leaves: require('../../assets/staples/dill_leaves.webp'),
  colocasia_leaves: require('../../assets/staples/colocasia_leaves.webp'),
  moringa_leaves: require('../../assets/staples/moringa_leaves.webp'),
  lettuce: require('../../assets/staples/lettuce.webp'),
  sorrel_leaves: require('../../assets/staples/sorrel_leaves.webp'),
  curry_leaves: require('../../assets/staples/curry_leaves.webp'),
  coriander_leaves: require('../../assets/staples/coriander_leaves.webp'),
  mint_leaves: require('../../assets/staples/mint_leaves.webp'),
  basil: require('../../assets/staples/basil.webp'),
  parsley: require('../../assets/staples/parsley.webp'),
  oregano: require('../../assets/staples/oregano.webp'),
  thyme: require('../../assets/staples/thyme.webp'),
  rosemary: require('../../assets/staples/rosemary.webp'),
  bay_leaf: require('../../assets/staples/bay_leaf.webp'),
  turmeric_powder: require('../../assets/staples/turmeric_powder.webp'),
  red_chilli_powder: require('../../assets/staples/red_chilli_powder.webp'),
  coriander_powder: require('../../assets/staples/coriander_powder.webp'),
  coriander_seeds: require('../../assets/staples/coriander_seeds.webp'),
  cumin_powder: require('../../assets/staples/cumin_powder.webp'),
  cumin_seeds: require('../../assets/staples/cumin_seeds.webp'),
  mustard_seeds: require('../../assets/staples/mustard_seeds.webp'),
  fenugreek_seeds: require('../../assets/staples/fenugreek_seeds.webp'),
  fennel_seeds: require('../../assets/staples/fennel_seeds.webp'),
  carom_seeds: require('../../assets/staples/carom_seeds.webp'),
  nigella_seeds: require('../../assets/staples/nigella_seeds.webp'),
  asafoetida: require('../../assets/staples/asafoetida.webp'),
  black_pepper: require('../../assets/staples/black_pepper.webp'),
  white_pepper: require('../../assets/staples/white_pepper.webp'),
  cardamom_green: require('../../assets/staples/cardamom_green.webp'),
  cardamom_black: require('../../assets/staples/cardamom_black.webp'),
  cloves: require('../../assets/staples/cloves.webp'),
  cinnamon: require('../../assets/staples/cinnamon.webp'),
  nutmeg: require('../../assets/staples/nutmeg.webp'),
  mace: require('../../assets/staples/mace.webp'),
  star_anise: require('../../assets/staples/star_anise.webp'),
  dry_red_chilli: require('../../assets/staples/dry_red_chilli.webp'),
  dry_ginger: require('../../assets/staples/dry_ginger.webp'),
  tamarind: require('../../assets/staples/tamarind.webp'),
  dry_mango_powder: require('../../assets/staples/dry_mango_powder.webp'),
  kokum: require('../../assets/staples/kokum.webp'),
  poppy_seeds: require('../../assets/staples/poppy_seeds.webp'),
  stone_flower: require('../../assets/staples/stone_flower.webp'),
  saffron: require('../../assets/staples/saffron.webp'),
  garam_masala: require('../../assets/staples/garam_masala.webp'),
  sambar_powder: require('../../assets/staples/sambar_powder.webp'),
  rasam_powder: require('../../assets/staples/rasam_powder.webp'),
  chaat_masala: require('../../assets/staples/chaat_masala.webp'),
  pav_bhaji_masala: require('../../assets/staples/pav_bhaji_masala.webp'),
  biryani_masala: require('../../assets/staples/biryani_masala.webp'),
  kitchen_king_masala: require('../../assets/staples/kitchen_king_masala.webp'),
  tandoori_masala: require('../../assets/staples/tandoori_masala.webp'),
  kasuri_methi: require('../../assets/staples/kasuri_methi.webp'),
  everest_garam: require('../../assets/staples/everest_garam.webp'),
  rice: require('../../assets/staples/rice.webp'),
  brown_rice: require('../../assets/staples/brown_rice.webp'),
  basmati_rice: require('../../assets/staples/basmati_rice.webp'),
  poha: require('../../assets/staples/poha.webp'),
  puffed_rice: require('../../assets/staples/puffed_rice.webp'),
  wheat: require('../../assets/staples/wheat.webp'),
  broken_wheat: require('../../assets/staples/broken_wheat.webp'),
  semolina: require('../../assets/staples/semolina.webp'),
  vermicelli: require('../../assets/staples/vermicelli.webp'),
  oats: require('../../assets/staples/oats.webp'),
  barley: require('../../assets/staples/barley.webp'),
  quinoa: require('../../assets/staples/quinoa.webp'),
  ragi: require('../../assets/staples/ragi.webp'),
  bajra: require('../../assets/staples/bajra.webp'),
  jowar: require('../../assets/staples/jowar.webp'),
  foxtail_millet: require('../../assets/staples/foxtail_millet.webp'),
  little_millet: require('../../assets/staples/little_millet.webp'),
  kodo_millet: require('../../assets/staples/kodo_millet.webp'),
  sabudana: require('../../assets/staples/sabudana.webp'),
  wheat_flour: require('../../assets/staples/wheat_flour.webp'),
  all_purpose_flour: require('../../assets/staples/all_purpose_flour.webp'),
  gram_flour: require('../../assets/staples/gram_flour.webp'),
  rice_flour: require('../../assets/staples/rice_flour.webp'),
  corn_flour: require('../../assets/staples/corn_flour.webp'),
  corn_meal: require('../../assets/staples/corn_meal.webp'),
  ragi_flour: require('../../assets/staples/ragi_flour.webp'),
  jowar_flour: require('../../assets/staples/jowar_flour.webp'),
  bajra_flour: require('../../assets/staples/bajra_flour.webp'),
  semolina_flour: require('../../assets/staples/semolina_flour.webp'),
  toor_dal: require('../../assets/staples/toor_dal.webp'),
  moong_dal: require('../../assets/staples/moong_dal.webp'),
  whole_moong: require('../../assets/staples/whole_moong.webp'),
  moong_sprouts: require('../../assets/staples/moong_sprouts.webp'),
  masoor_dal: require('../../assets/staples/masoor_dal.webp'),
  whole_masoor: require('../../assets/staples/whole_masoor.webp'),
  urad_dal: require('../../assets/staples/urad_dal.webp'),
  whole_urad: require('../../assets/staples/whole_urad.webp'),
  chana_dal: require('../../assets/staples/chana_dal.webp'),
  kabuli_chana: require('../../assets/staples/kabuli_chana.webp'),
  kala_chana: require('../../assets/staples/kala_chana.webp'),
  rajma: require('../../assets/staples/rajma.webp'),
  lobia: require('../../assets/staples/lobia.webp'),
  moth_beans: require('../../assets/staples/moth_beans.webp'),
  horse_gram: require('../../assets/staples/horse_gram.webp'),
  green_moong_dal: require('../../assets/staples/green_moong_dal.webp'),
  soya_chunks: require('../../assets/staples/soya_chunks.webp'),
  milk: require('../../assets/staples/milk.webp'),
  curd: require('../../assets/staples/curd.webp'),
  buttermilk: require('../../assets/staples/buttermilk.webp'),
  paneer: require('../../assets/staples/paneer.webp'),
  cheese: require('../../assets/staples/cheese.webp'),
  butter: require('../../assets/staples/butter.webp'),
  ghee: require('../../assets/staples/ghee.webp'),
  cream: require('../../assets/staples/cream.webp'),
  condensed_milk: require('../../assets/staples/condensed_milk.webp'),
  khoya: require('../../assets/staples/khoya.webp'),
  milk_powder: require('../../assets/staples/milk_powder.webp'),
  egg: require('../../assets/staples/egg.webp'),
  chicken: require('../../assets/staples/chicken.webp'),
  chicken_leg: require('../../assets/staples/chicken_leg.webp'),
  chicken_wings: require('../../assets/staples/chicken_wings.webp'),
  chicken_keema: require('../../assets/staples/chicken_keema.webp'),
  duck: require('../../assets/staples/duck.webp'),
  turkey: require('../../assets/staples/turkey.webp'),
  mutton: require('../../assets/staples/mutton.webp'),
  mutton_keema: require('../../assets/staples/mutton_keema.webp'),
  beef: require('../../assets/staples/beef.webp'),
  pork: require('../../assets/staples/pork.webp'),
  liver: require('../../assets/staples/liver.webp'),
  fish: require('../../assets/staples/fish.webp'),
  rohu: require('../../assets/staples/rohu.webp'),
  katla: require('../../assets/staples/katla.webp'),
  pomfret: require('../../assets/staples/pomfret.webp'),
  mackerel: require('../../assets/staples/mackerel.webp'),
  sardine: require('../../assets/staples/sardine.webp'),
  tuna: require('../../assets/staples/tuna.webp'),
  salmon: require('../../assets/staples/salmon.webp'),
  prawns: require('../../assets/staples/prawns.webp'),
  crab: require('../../assets/staples/crab.webp'),
  squid: require('../../assets/staples/squid.webp'),
  peanut: require('../../assets/staples/peanut.webp'),
  cashew: require('../../assets/staples/cashew.webp'),
  almond: require('../../assets/staples/almond.webp'),
  pistachio: require('../../assets/staples/pistachio.webp'),
  walnut: require('../../assets/staples/walnut.webp'),
  hazelnut: require('../../assets/staples/hazelnut.webp'),
  pine_nuts: require('../../assets/staples/pine_nuts.webp'),
  coconut: require('../../assets/staples/coconut.webp'),
  dry_coconut: require('../../assets/staples/dry_coconut.webp'),
  sesame_seeds: require('../../assets/staples/sesame_seeds.webp'),
  flax_seeds: require('../../assets/staples/flax_seeds.webp'),
  chia_seeds: require('../../assets/staples/chia_seeds.webp'),
  sunflower_seeds: require('../../assets/staples/sunflower_seeds.webp'),
  pumpkin_seeds: require('../../assets/staples/pumpkin_seeds.webp'),
  watermelon_seeds: require('../../assets/staples/watermelon_seeds.webp'),
  basil_seeds: require('../../assets/staples/basil_seeds.webp'),
  raisin: require('../../assets/staples/raisin.webp'),
  date: require('../../assets/staples/date.webp'),
  fig: require('../../assets/staples/fig.webp'),
  apricot: require('../../assets/staples/apricot.webp'),
  prune: require('../../assets/staples/prune.webp'),
  banana: require('../../assets/staples/banana.webp'),
  apple: require('../../assets/staples/apple.webp'),
  mango: require('../../assets/staples/mango.webp'),
  orange: require('../../assets/staples/orange.webp'),
  sweet_lime: require('../../assets/staples/sweet_lime.webp'),
  lemon: require('../../assets/staples/lemon.webp'),
  grapes: require('../../assets/staples/grapes.webp'),
  pomegranate: require('../../assets/staples/pomegranate.webp'),
  watermelon: require('../../assets/staples/watermelon.webp'),
  muskmelon: require('../../assets/staples/muskmelon.webp'),
  papaya: require('../../assets/staples/papaya.webp'),
  guava: require('../../assets/staples/guava.webp'),
  pineapple: require('../../assets/staples/pineapple.webp'),
  pear: require('../../assets/staples/pear.webp'),
  custard_apple: require('../../assets/staples/custard_apple.webp'),
  sapota: require('../../assets/staples/sapota.webp'),
  jackfruit: require('../../assets/staples/jackfruit.webp'),
  strawberry: require('../../assets/staples/strawberry.webp'),
  kiwi: require('../../assets/staples/kiwi.webp'),
  avocado: require('../../assets/staples/avocado.webp'),
  litchi: require('../../assets/staples/litchi.webp'),
  sugar: require('../../assets/staples/sugar.webp'),
  brown_sugar: require('../../assets/staples/brown_sugar.webp'),
  jaggery: require('../../assets/staples/jaggery.webp'),
  honey: require('../../assets/staples/honey.webp'),
  powdered_sugar: require('../../assets/staples/powdered_sugar.webp'),
  palm_sugar: require('../../assets/staples/palm_sugar.webp'),
  rock_sugar: require('../../assets/staples/rock_sugar.webp'),
  maple_syrup: require('../../assets/staples/maple_syrup.webp'),
  salt: require('../../assets/staples/salt.webp'),
  rock_salt: require('../../assets/staples/rock_salt.webp'),
  black_salt: require('../../assets/staples/black_salt.webp'),
  vinegar: require('../../assets/staples/vinegar.webp'),
  soy_sauce: require('../../assets/staples/soy_sauce.webp'),
  tomato_ketchup: require('../../assets/staples/tomato_ketchup.webp'),
  chilli_sauce: require('../../assets/staples/chilli_sauce.webp'),
  vinegar_rice: require('../../assets/staples/vinegar_rice.webp'),
  mayonnaise: require('../../assets/staples/mayonnaise.webp'),
  mustard_sauce: require('../../assets/staples/mustard_sauce.webp'),
  fish_sauce: require('../../assets/staples/fish_sauce.webp'),
  oyster_sauce: require('../../assets/staples/oyster_sauce.webp'),
  vinegar_balsamic: require('../../assets/staples/vinegar_balsamic.webp'),
  pickle: require('../../assets/staples/pickle.webp'),
  papad: require('../../assets/staples/papad.webp'),
  tamarind_paste: require('../../assets/staples/tamarind_paste.webp'),
  ginger_garlic_paste: require('../../assets/staples/ginger_garlic_paste.webp'),
  tomato_puree: require('../../assets/staples/tomato_puree.webp'),
  coconut_milk: require('../../assets/staples/coconut_milk.webp'),
  sunflower_oil: require('../../assets/staples/sunflower_oil.webp'),
  groundnut_oil: require('../../assets/staples/groundnut_oil.webp'),
  mustard_oil: require('../../assets/staples/mustard_oil.webp'),
  coconut_oil: require('../../assets/staples/coconut_oil.webp'),
  sesame_oil: require('../../assets/staples/sesame_oil.webp'),
  olive_oil: require('../../assets/staples/olive_oil.webp'),
  rice_bran_oil: require('../../assets/staples/rice_bran_oil.webp'),
  vanaspati: require('../../assets/staples/vanaspati.webp'),
  soybean_oil: require('../../assets/staples/soybean_oil.webp'),
  baking_powder: require('../../assets/staples/baking_powder.webp'),
  baking_soda: require('../../assets/staples/baking_soda.webp'),
  yeast: require('../../assets/staples/yeast.webp'),
  vanilla_essence: require('../../assets/staples/vanilla_essence.webp'),
  cocoa_powder: require('../../assets/staples/cocoa_powder.webp'),
  chocolate: require('../../assets/staples/chocolate.webp'),
  gelatin: require('../../assets/staples/gelatin.webp'),
  agar_agar: require('../../assets/staples/agar_agar.webp'),
  custard_powder: require('../../assets/staples/custard_powder.webp'),
  food_color: require('../../assets/staples/food_color.webp'),
  tea: require('../../assets/staples/tea.webp'),
  coffee: require('../../assets/staples/coffee.webp'),
  drinking_chocolate: require('../../assets/staples/drinking_chocolate.webp'),
  soda_water: require('../../assets/staples/soda_water.webp'),
  fruit_juice: require('../../assets/staples/fruit_juice.webp'),
  coconut_water: require('../../assets/staples/coconut_water.webp'),
  bread: require('../../assets/staples/bread.webp'),
  pasta: require('../../assets/staples/pasta.webp'),
  noodles: require('../../assets/staples/noodles.webp'),
  biscuit: require('../../assets/staples/biscuit.webp'),
  cornflakes: require('../../assets/staples/cornflakes.webp'),
  tofu: require('../../assets/staples/tofu.webp'),
  spring_roll_sheet: require('../../assets/staples/spring_roll_sheet.webp'),
  idli_batter: require('../../assets/staples/idli_batter.webp'),
  ready_masala_paste: require('../../assets/staples/ready_masala_paste.webp'),
  water: require('../../assets/staples/water.webp'),
  ice: require('../../assets/staples/ice.webp'),
  rose_water: require('../../assets/staples/rose_water.webp'),
  kewra_water: require('../../assets/staples/kewra_water.webp'),
  vark: require('../../assets/staples/vark.webp'),
  pointed_gourd: require('../../assets/staples/pointed_gourd.webp'),
  spiny_gourd: require('../../assets/staples/spiny_gourd.webp'),
  chayote: require('../../assets/staples/chayote.webp'),
  sponge_gourd: require('../../assets/staples/sponge_gourd.webp'),
  field_beans: require('../../assets/staples/field_beans.webp'),
  sword_beans: require('../../assets/staples/sword_beans.webp'),
  winged_beans: require('../../assets/staples/winged_beans.webp'),
  long_beans: require('../../assets/staples/long_beans.webp'),
  edamame: require('../../assets/staples/edamame.webp'),
  asparagus: require('../../assets/staples/asparagus.webp'),
  celery: require('../../assets/staples/celery.webp'),
  leek: require('../../assets/staples/leek.webp'),
  artichoke: require('../../assets/staples/artichoke.webp'),
  fennel_bulb: require('../../assets/staples/fennel_bulb.webp'),
  bok_choy: require('../../assets/staples/bok_choy.webp'),
  kale: require('../../assets/staples/kale.webp'),
  red_cabbage: require('../../assets/staples/red_cabbage.webp'),
  baby_corn: require('../../assets/staples/baby_corn.webp'),
  water_chestnut: require('../../assets/staples/water_chestnut.webp'),
  lotus_stem: require('../../assets/staples/lotus_stem.webp'),
  bamboo_shoot: require('../../assets/staples/bamboo_shoot.webp'),
  sweet_potato: require('../../assets/staples/sweet_potato.webp'),
  taro_root: require('../../assets/staples/taro_root.webp'),
  elephant_foot_yam: require('../../assets/staples/elephant_foot_yam.webp'),
  purple_yam: require('../../assets/staples/purple_yam.webp'),
  white_yam: require('../../assets/staples/white_yam.webp'),
  raw_jackfruit: require('../../assets/staples/raw_jackfruit.webp'),
  banana_flower: require('../../assets/staples/banana_flower.webp'),
  banana_stem: require('../../assets/staples/banana_stem.webp'),
  cassava: require('../../assets/staples/cassava.webp'),
  turnip: require('../../assets/staples/turnip.webp'),
  kohlrabi: require('../../assets/staples/kohlrabi.webp'),
  parsnip: require('../../assets/staples/parsnip.webp'),
  green_tomato: require('../../assets/staples/green_tomato.webp'),
  sun_dried_tomato: require('../../assets/staples/sun_dried_tomato.webp'),
  olives: require('../../assets/staples/olives.webp'),
  gherkins: require('../../assets/staples/gherkins.webp'),
  jalapeno: require('../../assets/staples/jalapeno.webp'),
  celeriac: require('../../assets/staples/celeriac.webp'),
  savoy_cabbage: require('../../assets/staples/savoy_cabbage.webp'),
  brussels_sprouts: require('../../assets/staples/brussels_sprouts.webp'),
  snow_peas: require('../../assets/staples/snow_peas.webp'),
  sugar_snap_peas: require('../../assets/staples/sugar_snap_peas.webp'),
  tomatillo: require('../../assets/staples/tomatillo.webp'),
  red_bell_pepper: require('../../assets/staples/red_bell_pepper.webp'),
  yellow_bell_pepper: require('../../assets/staples/yellow_bell_pepper.webp'),
  fingerroot: require('../../assets/staples/fingerroot.webp'),
  galangal: require('../../assets/staples/galangal.webp'),
  fresh_turmeric: require('../../assets/staples/fresh_turmeric.webp'),
  mango_ginger: require('../../assets/staples/mango_ginger.webp'),
  black_radish: require('../../assets/staples/black_radish.webp'),
  rutabaga: require('../../assets/staples/rutabaga.webp'),
  jerusalem_artichoke: require('../../assets/staples/jerusalem_artichoke.webp'),
  horseradish: require('../../assets/staples/horseradish.webp'),
  cluster_fig: require('../../assets/staples/cluster_fig.webp'),
  malabar_spinach: require('../../assets/staples/malabar_spinach.webp'),
  water_spinach: require('../../assets/staples/water_spinach.webp'),
  purslane: require('../../assets/staples/purslane.webp'),
  swiss_chard: require('../../assets/staples/swiss_chard.webp'),
  arugula: require('../../assets/staples/arugula.webp'),
  radish_greens: require('../../assets/staples/radish_greens.webp'),
  tamarind_leaves: require('../../assets/staples/tamarind_leaves.webp'),
  agathi_leaves: require('../../assets/staples/agathi_leaves.webp'),
  ponnanganni_greens: require('../../assets/staples/ponnanganni_greens.webp'),
  pumpkin_leaves: require('../../assets/staples/pumpkin_leaves.webp'),
  lemongrass: require('../../assets/staples/lemongrass.webp'),
  kaffir_lime_leaf: require('../../assets/staples/kaffir_lime_leaf.webp'),
  celery_leaf: require('../../assets/staples/celery_leaf.webp'),
  sage: require('../../assets/staples/sage.webp'),
  marjoram: require('../../assets/staples/marjoram.webp'),
  chives: require('../../assets/staples/chives.webp'),
  tarragon: require('../../assets/staples/tarragon.webp'),
  thai_basil: require('../../assets/staples/thai_basil.webp'),
  holy_basil: require('../../assets/staples/holy_basil.webp'),
  sawtooth_coriander: require('../../assets/staples/sawtooth_coriander.webp'),
  winter_savory: require('../../assets/staples/winter_savory.webp'),
  borage: require('../../assets/staples/borage.webp'),
  epazote: require('../../assets/staples/epazote.webp'),
  vietnamese_coriander: require('../../assets/staples/vietnamese_coriander.webp'),
  shiso: require('../../assets/staples/shiso.webp'),
  jamun: require('../../assets/staples/jamun.webp'),
  ber: require('../../assets/staples/ber.webp'),
  amla: require('../../assets/staples/amla.webp'),
  wood_apple: require('../../assets/staples/wood_apple.webp'),
  bael: require('../../assets/staples/bael.webp'),
  tamarind_fruit: require('../../assets/staples/tamarind_fruit.webp'),
  sweet_tamarind: require('../../assets/staples/sweet_tamarind.webp'),
  star_fruit: require('../../assets/staples/star_fruit.webp'),
  mangosteen: require('../../assets/staples/mangosteen.webp'),
  rambutan: require('../../assets/staples/rambutan.webp'),
  dragon_fruit: require('../../assets/staples/dragon_fruit.webp'),
  passion_fruit: require('../../assets/staples/passion_fruit.webp'),
  longan: require('../../assets/staples/longan.webp'),
  phalsa: require('../../assets/staples/phalsa.webp'),
  mulberry: require('../../assets/staples/mulberry.webp'),
  fresh_fig: require('../../assets/staples/fresh_fig.webp'),
  plum: require('../../assets/staples/plum.webp'),
  peach: require('../../assets/staples/peach.webp'),
  fresh_apricot: require('../../assets/staples/fresh_apricot.webp'),
  cherry: require('../../assets/staples/cherry.webp'),
  blackberry: require('../../assets/staples/blackberry.webp'),
  blueberry: require('../../assets/staples/blueberry.webp'),
  raspberry: require('../../assets/staples/raspberry.webp'),
  cranberry: require('../../assets/staples/cranberry.webp'),
  karonda: require('../../assets/staples/karonda.webp'),
  sugarcane: require('../../assets/staples/sugarcane.webp'),
  tadgola: require('../../assets/staples/tadgola.webp'),
  breadfruit: require('../../assets/staples/breadfruit.webp'),
  grapefruit: require('../../assets/staples/grapefruit.webp'),
  pomelo: require('../../assets/staples/pomelo.webp'),
  mandarin: require('../../assets/staples/mandarin.webp'),
  kinnow: require('../../assets/staples/kinnow.webp'),
  malta_orange: require('../../assets/staples/malta_orange.webp'),
  honeydew_melon: require('../../assets/staples/honeydew_melon.webp'),
  tendu_fruit: require('../../assets/staples/tendu_fruit.webp'),
  persimmon: require('../../assets/staples/persimmon.webp'),
  ramphal: require('../../assets/staples/ramphal.webp'),
  soursop: require('../../assets/staples/soursop.webp'),
  egg_fruit: require('../../assets/staples/egg_fruit.webp'),
  rose_apple: require('../../assets/staples/rose_apple.webp'),
  kair: require('../../assets/staples/kair.webp'),
  gunda: require('../../assets/staples/gunda.webp'),
  monkey_jack: require('../../assets/staples/monkey_jack.webp'),
  santol: require('../../assets/staples/santol.webp'),
  pink_guava: require('../../assets/staples/pink_guava.webp'),
  fresh_date: require('../../assets/staples/fresh_date.webp'),
  apple_ber: require('../../assets/staples/apple_ber.webp'),
  makhana: require('../../assets/staples/makhana.webp'),
  chironji: require('../../assets/staples/chironji.webp'),
  tutti_frutti: require('../../assets/staples/tutti_frutti.webp'),
  candied_cherry: require('../../assets/staples/candied_cherry.webp'),
  dried_cranberry: require('../../assets/staples/dried_cranberry.webp'),
  dried_blueberry: require('../../assets/staples/dried_blueberry.webp'),
  dried_kiwi: require('../../assets/staples/dried_kiwi.webp'),
  dried_mango: require('../../assets/staples/dried_mango.webp'),
  dried_pineapple: require('../../assets/staples/dried_pineapple.webp'),
  dried_papaya: require('../../assets/staples/dried_papaya.webp'),
  dried_jamun: require('../../assets/staples/dried_jamun.webp'),
  dried_amla: require('../../assets/staples/dried_amla.webp'),
  black_raisin: require('../../assets/staples/black_raisin.webp'),
  munakka: require('../../assets/staples/munakka.webp'),
  dried_date: require('../../assets/staples/dried_date.webp'),
  ajwa_date: require('../../assets/staples/ajwa_date.webp'),
  medjool_date: require('../../assets/staples/medjool_date.webp'),
  kimia_date: require('../../assets/staples/kimia_date.webp'),
  turkish_apricot: require('../../assets/staples/turkish_apricot.webp'),
  dried_mulberry: require('../../assets/staples/dried_mulberry.webp'),
  amla_candy: require('../../assets/staples/amla_candy.webp'),
  shahi_jeera: require('../../assets/staples/shahi_jeera.webp'),
  dill_seeds: require('../../assets/staples/dill_seeds.webp'),
  celery_seeds: require('../../assets/staples/celery_seeds.webp'),
  dried_pomegranate_seeds: require('../../assets/staples/dried_pomegranate_seeds.webp'),
  allspice: require('../../assets/staples/allspice.webp'),
  paprika: require('../../assets/staples/paprika.webp'),
  cayenne_pepper: require('../../assets/staples/cayenne_pepper.webp'),
  smoked_paprika: require('../../assets/staples/smoked_paprika.webp'),
  juniper_berries: require('../../assets/staples/juniper_berries.webp'),
  sumac: require('../../assets/staples/sumac.webp'),
  zaatar: require('../../assets/staples/zaatar.webp'),
  dried_marjoram: require('../../assets/staples/dried_marjoram.webp'),
  dried_thyme: require('../../assets/staples/dried_thyme.webp'),
  dried_basil: require('../../assets/staples/dried_basil.webp'),
  dried_mint: require('../../assets/staples/dried_mint.webp'),
  long_pepper: require('../../assets/staples/long_pepper.webp'),
  cubeb: require('../../assets/staples/cubeb.webp'),
  grains_of_paradise: require('../../assets/staples/grains_of_paradise.webp'),
  marathi_moggu: require('../../assets/staples/marathi_moggu.webp'),
  licorice_root: require('../../assets/staples/licorice_root.webp'),
  vanilla_bean: require('../../assets/staples/vanilla_bean.webp'),
  amchur_whole: require('../../assets/staples/amchur_whole.webp'),
  dried_rose_petals: require('../../assets/staples/dried_rose_petals.webp'),
  tirphal: require('../../assets/staples/tirphal.webp'),
  goda_masala: require('../../assets/staples/goda_masala.webp'),
  chettinad_masala: require('../../assets/staples/chettinad_masala.webp'),
  kolhapuri_masala: require('../../assets/staples/kolhapuri_masala.webp'),
  malvani_masala: require('../../assets/staples/malvani_masala.webp'),
  panch_phoron: require('../../assets/staples/panch_phoron.webp'),
  bafat_powder: require('../../assets/staples/bafat_powder.webp'),
  gunpowder_podi: require('../../assets/staples/gunpowder_podi.webp'),
  milagai_podi: require('../../assets/staples/milagai_podi.webp'),
  curry_powder: require('../../assets/staples/curry_powder.webp'),
  madras_curry_powder: require('../../assets/staples/madras_curry_powder.webp'),
  shahi_garam_masala: require('../../assets/staples/shahi_garam_masala.webp'),
  butter_chicken_masala: require('../../assets/staples/butter_chicken_masala.webp'),
  chole_masala: require('../../assets/staples/chole_masala.webp'),
  kala_masala: require('../../assets/staples/kala_masala.webp'),
  dhansak_masala: require('../../assets/staples/dhansak_masala.webp'),
  xacuti_masala: require('../../assets/staples/xacuti_masala.webp'),
  rajma_masala: require('../../assets/staples/rajma_masala.webp'),
  sabji_masala: require('../../assets/staples/sabji_masala.webp'),
  paneer_masala: require('../../assets/staples/paneer_masala.webp'),
  kadhai_masala: require('../../assets/staples/kadhai_masala.webp'),
  paruppu_podi: require('../../assets/staples/paruppu_podi.webp'),
  curry_leaf_podi: require('../../assets/staples/curry_leaf_podi.webp'),
  vangi_bath_masala: require('../../assets/staples/vangi_bath_masala.webp'),
  puliyogare_masala: require('../../assets/staples/puliyogare_masala.webp'),
  bisi_bele_bath_masala: require('../../assets/staples/bisi_bele_bath_masala.webp'),
  misal_masala: require('../../assets/staples/misal_masala.webp'),
  tea_masala: require('../../assets/staples/tea_masala.webp'),
  jaljeera_powder: require('../../assets/staples/jaljeera_powder.webp'),
  worcestershire_sauce: require('../../assets/staples/worcestershire_sauce.webp'),
  tabasco_sauce: require('../../assets/staples/tabasco_sauce.webp'),
  sriracha: require('../../assets/staples/sriracha.webp'),
  hoisin_sauce: require('../../assets/staples/hoisin_sauce.webp'),
  teriyaki_sauce: require('../../assets/staples/teriyaki_sauce.webp'),
  tahini: require('../../assets/staples/tahini.webp'),
  peanut_butter: require('../../assets/staples/peanut_butter.webp'),
  fruit_jam: require('../../assets/staples/fruit_jam.webp'),
  marmalade: require('../../assets/staples/marmalade.webp'),
  chocolate_spread: require('../../assets/staples/chocolate_spread.webp'),
  kasundi: require('../../assets/staples/kasundi.webp'),
  green_chutney: require('../../assets/staples/green_chutney.webp'),
  tamarind_chutney: require('../../assets/staples/tamarind_chutney.webp'),
  mint_chutney: require('../../assets/staples/mint_chutney.webp'),
  coconut_chutney: require('../../assets/staples/coconut_chutney.webp'),
  tomato_chutney: require('../../assets/staples/tomato_chutney.webp'),
  garlic_chutney: require('../../assets/staples/garlic_chutney.webp'),
  capers: require('../../assets/staples/capers.webp'),
  pesto: require('../../assets/staples/pesto.webp'),
  salsa: require('../../assets/staples/salsa.webp'),
  arrabbiata_sauce: require('../../assets/staples/arrabbiata_sauce.webp'),
  pasta_sauce: require('../../assets/staples/pasta_sauce.webp'),
  pizza_sauce: require('../../assets/staples/pizza_sauce.webp'),
  bechamel_base: require('../../assets/staples/bechamel_base.webp'),
  miso_paste: require('../../assets/staples/miso_paste.webp'),
  shrimp_paste: require('../../assets/staples/shrimp_paste.webp'),
  thai_red_curry_paste: require('../../assets/staples/thai_red_curry_paste.webp'),
  thai_green_curry_paste: require('../../assets/staples/thai_green_curry_paste.webp'),
  harissa: require('../../assets/staples/harissa.webp'),
  gochujang: require('../../assets/staples/gochujang.webp'),
  ranch_dressing: require('../../assets/staples/ranch_dressing.webp'),
  thousand_island_dressing: require('../../assets/staples/thousand_island_dressing.webp'),
  barbecue_sauce: require('../../assets/staples/barbecue_sauce.webp'),
  honey_mustard: require('../../assets/staples/honey_mustard.webp'),
  dijon_mustard: require('../../assets/staples/dijon_mustard.webp'),
  english_mustard: require('../../assets/staples/english_mustard.webp'),
  schezwan_chutney: require('../../assets/staples/schezwan_chutney.webp'),
  manchurian_sauce: require('../../assets/staples/manchurian_sauce.webp'),
  chilli_garlic_sauce: require('../../assets/staples/chilli_garlic_sauce.webp'),
  tartar_sauce: require('../../assets/staples/tartar_sauce.webp'),
  onion_paste: require('../../assets/staples/onion_paste.webp'),
  cashew_paste: require('../../assets/staples/cashew_paste.webp'),
  red_chilli_paste: require('../../assets/staples/red_chilli_paste.webp'),
  garlic_paste: require('../../assets/staples/garlic_paste.webp'),
  ginger_paste: require('../../assets/staples/ginger_paste.webp'),
  avakaya_paste: require('../../assets/staples/avakaya_paste.webp'),
  matta_rice: require('../../assets/staples/matta_rice.webp'),
  black_rice: require('../../assets/staples/black_rice.webp'),
  parboiled_rice: require('../../assets/staples/parboiled_rice.webp'),
  jasmine_rice: require('../../assets/staples/jasmine_rice.webp'),
  arborio_rice: require('../../assets/staples/arborio_rice.webp'),
  sticky_rice: require('../../assets/staples/sticky_rice.webp'),
  sona_masoori_rice: require('../../assets/staples/sona_masoori_rice.webp'),
  gobindobhog_rice: require('../../assets/staples/gobindobhog_rice.webp'),
  ambemohar_rice: require('../../assets/staples/ambemohar_rice.webp'),
  barnyard_millet: require('../../assets/staples/barnyard_millet.webp'),
  proso_millet: require('../../assets/staples/proso_millet.webp'),
  amaranth_grain: require('../../assets/staples/amaranth_grain.webp'),
  buckwheat_groats: require('../../assets/staples/buckwheat_groats.webp'),
  couscous: require('../../assets/staples/couscous.webp'),
  bulgur_wheat: require('../../assets/staples/bulgur_wheat.webp'),
  polenta: require('../../assets/staples/polenta.webp'),
  steel_cut_oats: require('../../assets/staples/steel_cut_oats.webp'),
  wheat_bran: require('../../assets/staples/wheat_bran.webp'),
  wheat_germ: require('../../assets/staples/wheat_germ.webp'),
  freekeh: require('../../assets/staples/freekeh.webp'),
  farro: require('../../assets/staples/farro.webp'),
  wild_rice: require('../../assets/staples/wild_rice.webp'),
  jowar_flakes: require('../../assets/staples/jowar_flakes.webp'),
  pearl_barley: require('../../assets/staples/pearl_barley.webp'),
  whole_brown_chana: require('../../assets/staples/whole_brown_chana.webp'),
  green_chana: require('../../assets/staples/green_chana.webp'),
  dried_green_peas: require('../../assets/staples/dried_green_peas.webp'),
  white_peas: require('../../assets/staples/white_peas.webp'),
  yellow_peas: require('../../assets/staples/yellow_peas.webp'),
  whole_soybean: require('../../assets/staples/whole_soybean.webp'),
  black_soybean: require('../../assets/staples/black_soybean.webp'),
  val_dal: require('../../assets/staples/val_dal.webp'),
  val_beans_whole: require('../../assets/staples/val_beans_whole.webp'),
  chitra_rajma: require('../../assets/staples/chitra_rajma.webp'),
  red_rajma: require('../../assets/staples/red_rajma.webp'),
  white_rajma: require('../../assets/staples/white_rajma.webp'),
  adzuki_beans: require('../../assets/staples/adzuki_beans.webp'),
  black_chickpea_split: require('../../assets/staples/black_chickpea_split.webp'),
  green_peas_split: require('../../assets/staples/green_peas_split.webp'),
  red_chori: require('../../assets/staples/red_chori.webp'),
  sattu: require('../../assets/staples/sattu.webp'),
  multigrain_atta: require('../../assets/staples/multigrain_atta.webp'),
  kuttu_atta: require('../../assets/staples/kuttu_atta.webp'),
  singhara_atta: require('../../assets/staples/singhara_atta.webp'),
  rajgira_flour: require('../../assets/staples/rajgira_flour.webp'),
  almond_flour: require('../../assets/staples/almond_flour.webp'),
  oat_flour: require('../../assets/staples/oat_flour.webp'),
  coconut_flour: require('../../assets/staples/coconut_flour.webp'),
  soya_flour: require('../../assets/staples/soya_flour.webp'),
  urad_flour: require('../../assets/staples/urad_flour.webp'),
  tapioca_flour: require('../../assets/staples/tapioca_flour.webp'),
  semolina_coarse: require('../../assets/staples/semolina_coarse.webp'),
  semolina_fine: require('../../assets/staples/semolina_fine.webp'),
  vital_wheat_gluten: require('../../assets/staples/vital_wheat_gluten.webp'),
  roasted_besan: require('../../assets/staples/roasted_besan.webp'),
  barley_flour: require('../../assets/staples/barley_flour.webp'),
  makhana_flour: require('../../assets/staples/makhana_flour.webp'),
  banana_flour: require('../../assets/staples/banana_flour.webp'),
  sweet_potato_flour: require('../../assets/staples/sweet_potato_flour.webp'),
  foxtail_millet_flour: require('../../assets/staples/foxtail_millet_flour.webp'),
  kodo_millet_flour: require('../../assets/staples/kodo_millet_flour.webp'),
  sago_flour: require('../../assets/staples/sago_flour.webp'),
  quinoa_flour: require('../../assets/staples/quinoa_flour.webp'),
  corn_starch: require('../../assets/staples/corn_starch.webp'),
  potato_starch: require('../../assets/staples/potato_starch.webp'),
  arrowroot_flour: require('../../assets/staples/arrowroot_flour.webp'),
  jackfruit_flour: require('../../assets/staples/jackfruit_flour.webp'),
  skimmed_milk: require('../../assets/staples/skimmed_milk.webp'),
  full_cream_milk: require('../../assets/staples/full_cream_milk.webp'),
  toned_milk: require('../../assets/staples/toned_milk.webp'),
  a2_milk: require('../../assets/staples/a2_milk.webp'),
  flavoured_milk: require('../../assets/staples/flavoured_milk.webp'),
  sour_cream: require('../../assets/staples/sour_cream.webp'),
  double_cream: require('../../assets/staples/double_cream.webp'),
  single_cream: require('../../assets/staples/single_cream.webp'),
  mozzarella: require('../../assets/staples/mozzarella.webp'),
  cheddar: require('../../assets/staples/cheddar.webp'),
  parmesan: require('../../assets/staples/parmesan.webp'),
  processed_cheese: require('../../assets/staples/processed_cheese.webp'),
  cheese_spread: require('../../assets/staples/cheese_spread.webp'),
  feta: require('../../assets/staples/feta.webp'),
  ricotta: require('../../assets/staples/ricotta.webp'),
  cream_cheese: require('../../assets/staples/cream_cheese.webp'),
  burrata: require('../../assets/staples/burrata.webp'),
  gouda: require('../../assets/staples/gouda.webp'),
  greek_yogurt: require('../../assets/staples/greek_yogurt.webp'),
  hung_curd: require('../../assets/staples/hung_curd.webp'),
  flavoured_yogurt: require('../../assets/staples/flavoured_yogurt.webp'),
  lassi: require('../../assets/staples/lassi.webp'),
  shrikhand: require('../../assets/staples/shrikhand.webp'),
  evaporated_milk: require('../../assets/staples/evaporated_milk.webp'),
  whey: require('../../assets/staples/whey.webp'),
  chhena: require('../../assets/staples/chhena.webp'),
  rabri: require('../../assets/staples/rabri.webp'),
  matha: require('../../assets/staples/matha.webp'),
  duck_egg: require('../../assets/staples/duck_egg.webp'),
  quail_egg: require('../../assets/staples/quail_egg.webp'),
  egg_whites: require('../../assets/staples/egg_whites.webp'),
  century_egg: require('../../assets/staples/century_egg.webp'),
  egg_yolk: require('../../assets/staples/egg_yolk.webp'),
  country_chicken: require('../../assets/staples/country_chicken.webp'),
  chicken_sausage: require('../../assets/staples/chicken_sausage.webp'),
  chicken_salami: require('../../assets/staples/chicken_salami.webp'),
  quail: require('../../assets/staples/quail.webp'),
  guinea_fowl: require('../../assets/staples/guinea_fowl.webp'),
  chicken_gizzard: require('../../assets/staples/chicken_gizzard.webp'),
  chicken_thigh: require('../../assets/staples/chicken_thigh.webp'),
  chicken_ham: require('../../assets/staples/chicken_ham.webp'),
  lamb: require('../../assets/staples/lamb.webp'),
  goat_brain: require('../../assets/staples/goat_brain.webp'),
  trotters: require('../../assets/staples/trotters.webp'),
  mutton_chops: require('../../assets/staples/mutton_chops.webp'),
  lamb_chops: require('../../assets/staples/lamb_chops.webp'),
  bacon: require('../../assets/staples/bacon.webp'),
  ham: require('../../assets/staples/ham.webp'),
  salami: require('../../assets/staples/salami.webp'),
  sausage: require('../../assets/staples/sausage.webp'),
  pork_ribs: require('../../assets/staples/pork_ribs.webp'),
  pork_belly: require('../../assets/staples/pork_belly.webp'),
  cold_cuts: require('../../assets/staples/cold_cuts.webp'),
  goat_liver: require('../../assets/staples/goat_liver.webp'),
  goat_kidney: require('../../assets/staples/goat_kidney.webp'),
  beef_steak: require('../../assets/staples/beef_steak.webp'),
  goat_tongue: require('../../assets/staples/goat_tongue.webp'),
  surmai: require('../../assets/staples/surmai.webp'),
  hilsa: require('../../assets/staples/hilsa.webp'),
  bombay_duck: require('../../assets/staples/bombay_duck.webp'),
  basa: require('../../assets/staples/basa.webp'),
  tilapia: require('../../assets/staples/tilapia.webp'),
  anchovy: require('../../assets/staples/anchovy.webp'),
  sole_fish: require('../../assets/staples/sole_fish.webp'),
  snapper: require('../../assets/staples/snapper.webp'),
  lobster: require('../../assets/staples/lobster.webp'),
  mussels: require('../../assets/staples/mussels.webp'),
  clams: require('../../assets/staples/clams.webp'),
  oyster: require('../../assets/staples/oyster.webp'),
  scallops: require('../../assets/staples/scallops.webp'),
  dried_fish: require('../../assets/staples/dried_fish.webp'),
  dried_prawns: require('../../assets/staples/dried_prawns.webp'),
  fish_roe: require('../../assets/staples/fish_roe.webp'),
  octopus: require('../../assets/staples/octopus.webp'),
  cuttlefish: require('../../assets/staples/cuttlefish.webp'),
  tiger_prawns: require('../../assets/staples/tiger_prawns.webp'),
  catfish: require('../../assets/staples/catfish.webp'),
  pearl_spot: require('../../assets/staples/pearl_spot.webp'),
  barramundi: require('../../assets/staples/barramundi.webp'),
  eel: require('../../assets/staples/eel.webp'),
  pecan: require('../../assets/staples/pecan.webp'),
  macadamia: require('../../assets/staples/macadamia.webp'),
  brazil_nut: require('../../assets/staples/brazil_nut.webp'),
  chestnut: require('../../assets/staples/chestnut.webp'),
  betel_nut: require('../../assets/staples/betel_nut.webp'),
  mixed_nuts: require('../../assets/staples/mixed_nuts.webp'),
  hemp_seeds: require('../../assets/staples/hemp_seeds.webp'),
  garden_cress_seeds: require('../../assets/staples/garden_cress_seeds.webp'),
  niger_seed: require('../../assets/staples/niger_seed.webp'),
  canola_oil: require('../../assets/staples/canola_oil.webp'),
  palm_oil: require('../../assets/staples/palm_oil.webp'),
  vegetable_oil: require('../../assets/staples/vegetable_oil.webp'),
  refined_oil: require('../../assets/staples/refined_oil.webp'),
  flaxseed_oil: require('../../assets/staples/flaxseed_oil.webp'),
  avocado_oil: require('../../assets/staples/avocado_oil.webp'),
  lard: require('../../assets/staples/lard.webp'),
  margarine: require('../../assets/staples/margarine.webp'),
  cooking_spray: require('../../assets/staples/cooking_spray.webp'),
  stevia: require('../../assets/staples/stevia.webp'),
  sugar_free: require('../../assets/staples/sugar_free.webp'),
  corn_syrup: require('../../assets/staples/corn_syrup.webp'),
  golden_syrup: require('../../assets/staples/golden_syrup.webp'),
  glucose: require('../../assets/staples/glucose.webp'),
  fructose: require('../../assets/staples/fructose.webp'),
  molasses: require('../../assets/staples/molasses.webp'),
  date_syrup: require('../../assets/staples/date_syrup.webp'),
  agave: require('../../assets/staples/agave.webp'),
  khandsari: require('../../assets/staples/khandsari.webp'),
  cream_of_tartar: require('../../assets/staples/cream_of_tartar.webp'),
  marzipan: require('../../assets/staples/marzipan.webp'),
  white_chocolate: require('../../assets/staples/white_chocolate.webp'),
  sprinkles: require('../../assets/staples/sprinkles.webp'),
  whipped_cream_powder: require('../../assets/staples/whipped_cream_powder.webp'),
  self_raising_flour: require('../../assets/staples/self_raising_flour.webp'),
  dough_conditioner: require('../../assets/staples/dough_conditioner.webp'),
  jelly_crystals: require('../../assets/staples/jelly_crystals.webp'),
  bread_crumbs: require('../../assets/staples/bread_crumbs.webp'),
  cold_drink: require('../../assets/staples/cold_drink.webp'),
  energy_drink: require('../../assets/staples/energy_drink.webp'),
  lemonade_mix: require('../../assets/staples/lemonade_mix.webp'),
  squash: require('../../assets/staples/squash.webp'),
  sherbet: require('../../assets/staples/sherbet.webp'),
  kombucha: require('../../assets/staples/kombucha.webp'),
  soy_milk: require('../../assets/staples/soy_milk.webp'),
  almond_milk: require('../../assets/staples/almond_milk.webp'),
  oat_milk: require('../../assets/staples/oat_milk.webp'),
  herbal_tea: require('../../assets/staples/herbal_tea.webp'),
  lemon_tea: require('../../assets/staples/lemon_tea.webp'),
  ice_tea: require('../../assets/staples/ice_tea.webp'),
  beer: require('../../assets/staples/beer.webp'),
  wine: require('../../assets/staples/wine.webp'),
  rum: require('../../assets/staples/rum.webp'),
  vodka: require('../../assets/staples/vodka.webp'),
  whisky: require('../../assets/staples/whisky.webp'),
  cooking_wine: require('../../assets/staples/cooking_wine.webp'),
  chips: require('../../assets/staples/chips.webp'),
  namkeen: require('../../assets/staples/namkeen.webp'),
  sev: require('../../assets/staples/sev.webp'),
  bhujia: require('../../assets/staples/bhujia.webp'),
  popcorn: require('../../assets/staples/popcorn.webp'),
  instant_soup: require('../../assets/staples/instant_soup.webp'),
  ready_to_eat: require('../../assets/staples/ready_to_eat.webp'),
  frozen_veg: require('../../assets/staples/frozen_veg.webp'),
  frozen_paratha: require('../../assets/staples/frozen_paratha.webp'),
  frozen_fries: require('../../assets/staples/frozen_fries.webp'),
  gravy_mix: require('../../assets/staples/gravy_mix.webp'),
  stock_cube: require('../../assets/staples/stock_cube.webp'),
  vegetable_stock: require('../../assets/staples/vegetable_stock.webp'),
  chicken_stock: require('../../assets/staples/chicken_stock.webp'),
  gelatin_sheets: require('../../assets/staples/gelatin_sheets.webp'),
  burger_bun: require('../../assets/staples/burger_bun.webp'),
  pizza_base: require('../../assets/staples/pizza_base.webp'),
  tortilla: require('../../assets/staples/tortilla.webp'),
  nachos: require('../../assets/staples/nachos.webp'),
  instant_idli_mix: require('../../assets/staples/instant_idli_mix.webp'),
  dosa_mix: require('../../assets/staples/dosa_mix.webp'),
  gulab_jamun_mix: require('../../assets/staples/gulab_jamun_mix.webp'),
  jelly: require('../../assets/staples/jelly.webp'),
  ice_cream: require('../../assets/staples/ice_cream.webp'),
  frozen_momos: require('../../assets/staples/frozen_momos.webp'),
  meetha_attar: require('../../assets/staples/meetha_attar.webp'),
  edible_camphor: require('../../assets/staples/edible_camphor.webp'),
  betel_leaf: require('../../assets/staples/betel_leaf.webp'),
  supari_mix: require('../../assets/staples/supari_mix.webp'),
  alum: require('../../assets/staples/alum.webp'),
  slaked_lime: require('../../assets/staples/slaked_lime.webp'),
  dough: require('../../assets/staples/dough.webp'),
  banana_leaf: require('../../assets/staples/banana_leaf.webp'),
  bathua: require('../../assets/staples/bathua.webp'),
  turkey_berry: require('../../assets/staples/turkey_berry.webp'),
  boondi: require('../../assets/staples/boondi.webp'),
  bassaru_powder: require('../../assets/staples/bassaru_powder.webp'),
  gojju_powder: require('../../assets/staples/gojju_powder.webp'),
  vangi_bhaat_masala: require('../../assets/staples/vangi_bhaat_masala.webp'),
  caesar_dressing: require('../../assets/staples/caesar_dressing.webp'),
  croutons: require('../../assets/staples/croutons.webp'),
};
